import { createAction, props } from '@ngrx/store';

import {
  LinkTemplate,
  LinkTemplateDetail,
  CreateLinkTemplatePayload,
  LinkTemplatesExportPayload,
  LinkTemplatesListMeta,
  LinkTemplatesListParams,
  UpdateLinkTemplatePayload,
} from '../models/link-template.model';

export const loadTemplates = createAction(
  '[Link Templates] Load Templates',
  props<LinkTemplatesListParams>()
);

export const loadTemplatesSuccess = createAction(
  '[Link Templates] Load Templates Success',
  props<{ templates: LinkTemplate[]; meta: LinkTemplatesListMeta }>()
);

export const loadTemplatesFailure = createAction(
  '[Link Templates] Load Templates Failure',
  props<{ error: string }>()
);

export const loadTemplate = createAction(
  '[Link Templates] Load Template',
  props<{ uuid: string }>()
);

export const loadTemplateSuccess = createAction(
  '[Link Templates] Load Template Success',
  props<{ template: LinkTemplateDetail }>()
);

export const loadTemplateFailure = createAction(
  '[Link Templates] Load Template Failure',
  props<{ error: string }>()
);

export const createTemplate = createAction(
  '[Link Templates] Create Template',
  props<{ payload: CreateLinkTemplatePayload }>()
);

export const createTemplateSuccess = createAction(
  '[Link Templates] Create Template Success',
  props<{ template: LinkTemplateDetail }>()
);

export const updateTemplate = createAction(
  '[Link Templates] Update Template',
  props<{ uuid: string; payload: UpdateLinkTemplatePayload }>()
);

export const updateTemplateSuccess = createAction(
  '[Link Templates] Update Template Success',
  props<{ template: LinkTemplateDetail }>()
);

export const deleteTemplate = createAction(
  '[Link Templates] Delete Template',
  props<{ uuid: string }>()
);

export const deleteTemplateSuccess = createAction(
  '[Link Templates] Delete Template Success',
  props<{ uuid: string }>()
);

export const setDefaultTemplate = createAction(
  '[Link Templates] Set Default Template',
  props<{ uuid: string }>()
);

export const setDefaultTemplateSuccess = createAction('[Link Templates] Set Default Template Success');

export const mutationFailure = createAction(
  '[Link Templates] Mutation Failure',
  props<{ error: string }>()
);

export const exportTemplates = createAction(
  '[Link Templates] Export Templates',
  props<{ payload: LinkTemplatesExportPayload }>()
);

export const exportTemplatesSuccess = createAction(
  '[Link Templates] Export Templates Success',
  props<{ message: string }>()
);

export const exportTemplatesFailure = createAction(
  '[Link Templates] Export Templates Failure',
  props<{ error: string }>()
);

export const resetCurrentTemplate = createAction('[Link Templates] Reset Current Template');
export const resetTemplatesState = createAction('[Link Templates] Reset State');
